export default {
	// serverURI: 'https://coffeetradetest.co-opbank.co.ke/api',

	// serverURI: 'https://172.16.19.207/api',

	// serverURI: 'http://172.16.20.112:8083/api',

	// serverURI: 'https://172.16.19.207/api',

	// serverURI: 'http://localhost:8083/api',


  // serverURI: 'https://172.16.20.14:8083/api',
	// serverURI: 'https://172.16.20.14/api',
	// serverURI: 'http://localhost:8083/api',

	// serverURI: 'https://172.16.19.207/api',
	// serverURI: 'https://172.16.20.14/api',

	// serverURI: 'http://172.16.20.112:8083/api',
	serverURI: 'https://coffeetrade.co-opbank.co.ke/api',
	// serverURI: 'https://coffeetradepreprod.co-opbank.co.ke/api',
	// serverURI: 'https://coffeetradesit.co-opbank.co.ke/api',
	fixedLayout: false,
	hideLogoOnMobile: false,
	sessionTimeout: 60,
	multifactorAuthOn: true,
	// https://coffeetrade.co-opbank.co.ke/api
	// http://192.168.0.28:8092/api
	// http://TRU02SDU23:8090/api
	// http://localhost:8092/api
	// https://172.16.19.174:8443/api
	// https://coffeetradetest.co-opbank.co.ke/api
	// https://coffeetradedemo.co-opbank.co.ke/api

}
